import { createContext } from 'react';

type OneloginContextProps = {
  oneloginSec: {
    state: string;
    nonce: string;
  };
};

export const OneloginContext = createContext<Partial<OneloginContextProps>>({});